type Variant = 'neutral' | 'pending' | 'approved' | 'rejected' | 'info';

type Props = {
  variant?: Variant;
  children: React.ReactNode;
  style?: React.CSSProperties;
};

const STYLES: Record<Variant, React.CSSProperties> = {
  neutral:  { color: 'var(--badge-neutral-text)',  background: 'var(--badge-neutral-bg)' },
  pending:  { color: 'var(--badge-pending-text)',  background: 'var(--badge-pending-bg)' },
  approved: { color: 'var(--badge-approved-text)', background: 'var(--badge-approved-bg)' },
  rejected: { color: 'var(--badge-rejected-text)', background: 'var(--badge-rejected-bg)' },
  info:     { color: 'var(--badge-info-text)',     background: 'var(--badge-info-bg)' },
};

export function Badge({ variant = 'neutral', children, style }: Props) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: 'var(--radius-full)',
        fontSize: 'var(--text-xs)',
        fontWeight: 600,
        letterSpacing: '0.03em',
        whiteSpace: 'nowrap',
        ...STYLES[variant],
        ...style,
      }}
    >
      {children}
    </span>
  );
}
